import styled from "styled-components";
import { colors, types } from "../../../libs";
import { Image, Button } from "react-bootstrap";


export const SelectTemplateContainer = styled.div<{ $isVisible: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    // padding: ${props => props.$isVisible ? '5px 15px' : '0px'};
    overflow: ${props => props.$isVisible ? 'visible' : 'hidden'};
    max-height: ${props => props.$isVisible ? '1000px' : '0'};
    
    transition: all 0.4s ease-in-out;
`;

export const SelectTemplateContainerHeader = styled.div`
    font-size: 14px;
    margin-bottom: 0.5rem;
`;

export const CardView = styled.div<{ $isVisible: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    opacity: ${props => props.$isVisible ? 1 : 0};
    max-height: ${props => props.$isVisible ? '200px' : '0'};
    overflow: hidden;
    transform: translateY(${props => props.$isVisible ? '0' : '-20px'});
    transition: all 0.4s ease-in-out;
    pointer-events: ${props => props.$isVisible ? 'auto' : 'none'};
    margin-bottom: 6px;
    background-color: ${colors.background.lightGrey};
    padding: ${props => props.$isVisible ? '16px 10px' : '0px'};
`;

export const GridView = styled.div<{ $isVisible: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    opacity: ${props => props.$isVisible ? 1 : 0};
    max-height: ${props => props.$isVisible ? '2000px' : '0'};
    overflow: ${props => props.$isVisible ? 'visible' : 'hidden'};
    transform: translateY(${props => props.$isVisible ? '0' : '20px'});
    transition: all 0.4s ease-in-out;
    pointer-events: ${props => props.$isVisible ? 'auto' : 'none'};
    margin-bottom: 6px;
    background-color: ${colors.background.lightGrey};
    padding: ${props => props.$isVisible ? '16px 10px' : '0px'};
`;

export const BackButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: ${colors.background.lightBlack};
    color: ${colors.text.white};
    border: 1px solid ${colors.background.greyWhite};
    border-radius: 8px;
    padding: 10px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;
    margin-left: auto;
    width: fit-content;

    &:hover {
        background: ${colors.background.greyWhite};
        border-color: ${colors.background.green};
    }

    span {
        ${types.body.normal};
    }
`;

export const TemplateCard = styled(Image)`
    height: 60px;
`;

export const CustomButton = styled(Button)`
  width: 40px;
  padding: 10px 0px;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;

  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s ease;
  border: 1px solid ${colors.background.greyWhite};

  &:hover {
    width: 150px;
    padding: 6px 12px;
    border: 1px solid ${colors.background.greyWhite};
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.span`
  display: none;
  margin-left: 8px;
  opacity: 0;
  transform: translateX(-10px);
  transition:
    opacity 0.2s ease-out 0.15s,
    transform 0.2s ease-out 0.15s;

  ${CustomButton}:hover & {
    display: inline-block;
    opacity: 1;
    transform: translateX(0);
  }
`;

export const SelectTemplateGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    width: 100%;
`;

export const SelectTemplateItem = styled(Image)<{ $isSelected?: boolean }>`
    width: 100%;
    height: auto;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    border-color: ${props => props.$isSelected ? colors.background.green : 'transparent'};

    &:hover {
        border-color: ${colors.background.green};
        transform: scale(1.05);
    }
`;